import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import PromoCodeButton from "../../buttons/PromoCodeButton";
import {removeOnePromotionPromoCode, setOnePromotionPromoCode} from "../../redux/actions";
import Translate from "../../localization/Translate";
import {getTranslate} from "../../localization/localizeSlice";
export default function ({}) {
    const dispatch = useDispatch();
    const onePromotionPromoCode = useSelector((state) => state.rootReducer.onePromotionPromoCode);
    const translate = useSelector((state) => getTranslate(state));

    let errors = [];
    if(onePromotionPromoCode !== false && onePromotionPromoCode.errors.length > 0)
    onePromotionPromoCode.errors.forEach((error) => {
        (error?.details_unreached_conditions ?? []).forEach((detail) => {
            let errorMessage = detail?.error_code ?? "";
            if(errorMessage !== ""){
                if(typeof detail.value !== "undefined"){
                    errorMessage += " ${value}";
                }
                errors.push(translate(errorMessage, detail));
            }
        });
    });

    let buttonName = <>
        <Translate  id="Code"/> - {onePromotionPromoCode.code}
        {errors.length > 0 ? "" : <> - <Translate id={onePromotionPromoCode.message}/></>}
        {errors.map((error) => <><br/><Translate id={error}/></>)}
    </>
    return <PromoCodeButton
        promotionSet={onePromotionPromoCode !== false}
        onRemovePromotion={() => {
            dispatch(removeOnePromotionPromoCode());
        }}
        promotionSetClass={onePromotionPromoCode.status === 'error' ? "negativeActionButton" :
            onePromotionPromoCode.status === 'pending' ? "warningActionButton" : "positiveActionButton"}
        promotionSetButtonName={buttonName}
        onPromotionInputDone={(value) => {
            dispatch(setOnePromotionPromoCode(value, "pending", "validating"));
        }}
    />;
}
